var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.headingLevel(),{tag:"component",class:[
    'suaw-heading',
    'suaw-heading--' + _vm.level,
    'suaw-heading--' + _vm.alignment,
    _vm.className
  ]},[_vm._v(" "+_vm._s(_vm.content)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }